module.exports = __webpack_public_path__ + "static/img/xmzs.b3c57cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xmzs.jpg
// module id = 0fnZ
// module chunks = 1